import { useEffect, useState } from "react";
import { ExternalLink, MapPin, Search } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

const TKGM_URL = "https://parselsorgu.tkgm.gov.tr/";

export default function ParselSorguPage() {
  const [loading, setLoading] = useState(true);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="parsel-sorgu-page">
      <Navbar />

      {/* Compact toolbar */}
      <div className="bg-[#161923] border-b border-white/10 px-5 py-2.5 flex items-center justify-between mt-20">
        <div className="flex items-center gap-3">
          <span className="text-sm font-extrabold tracking-tighter" style={{ fontFamily: "Outfit" }}>
            <span className="text-[#FF5A00]">BCT</span><span className="text-white"> Yapı</span>
          </span>
          <span className="text-white/20">|</span>
          <span className="text-xs text-white/60 font-medium" style={{ fontFamily: "Outfit" }}>Parsel Sorgulama</span>
          {loading && <div className="w-3 h-3 border-2 border-[#FF5A00]/30 border-t-[#FF5A00] rounded-full animate-spin" />}
        </div>
        <a href={TKGM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-3 py-1.5 text-xs text-white/60 hover:text-white bg-white/5 hover:bg-white/10 rounded-lg transition-colors" data-testid="tkgm-external-link">
          <ExternalLink size={12} /> Yeni sekmede aç
        </a>
      </div>

      {/* Info + iframe fallback */}
      <div className="flex-1 relative">
        <iframe
          src={TKGM_URL}
          title="TKGM Parsel Sorgulama"
          className="w-full h-[calc(100vh-130px)] min-h-[600px] border-0"
          onLoad={() => setLoading(false)}
          onError={() => setLoading(false)}
          data-testid="tkgm-iframe"
          allow="geolocation"
          referrerPolicy="no-referrer"
        />

        {/* Fallback info if iframe blocked */}
        <div className="hidden" id="iframe-fallback">
          <div className="max-w-2xl mx-auto px-5 py-20 text-center">
            <div className="w-16 h-16 rounded-2xl bg-[#FF5A00]/10 flex items-center justify-center mx-auto mb-6">
              <Search size={28} className="text-[#FF5A00]" />
            </div>
            <h2 className="text-2xl font-bold text-[#0C0C0C] mb-3" style={{ fontFamily: "Outfit" }}>Parsel Sorgulama</h2>
            <p className="text-gray-500 mb-8 leading-relaxed">
              TKGM Parsel Sorgulama sistemine aşağıdaki bağlantıdan erişebilirsiniz.
            </p>
            <a href={TKGM_URL} target="_blank" rel="noopener noreferrer" className="btn-modern btn-filled text-sm" data-testid="tkgm-fallback-link">
              <MapPin size={16} /> TKGM Parsel Sorgulama'ya Git
              <ExternalLink size={14} />
            </a>
          </div>
        </div>
      </div>

      <WhatsAppButton />
    </div>
  );
}
